<template>
  <div class="admin-profile">
    <h1>Profil Saya</h1>
    <div v-if="isLoading">Memuat profil...</div>
    <div v-else-if="profile" class="card">
      <form @submit.prevent="saveProfile">
        <input v-model="profile.full_name" placeholder="Nama Lengkap (untuk TTD)" />
        <input v-model="profile.email" type="email" placeholder="Email" required />
        <input v-model="profile.sipp_number" placeholder="Nomor SIPP" />
        <input v-model="profile.city" placeholder="Kota" />
        
        <label>Tanda Tangan Digital</label>
        <input type="file" @change="handleSignatureUpload" accept="image/png" />
        <div v-if="profile.signature_image_url" class="image-preview">
          <img :src="`${backendUrl}${profile.signature_image_url}`" alt="Preview Tanda Tangan">
        </div>

        <button type="submit" :disabled="isSaving">Simpan Perubahan</button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import apiClient from '@/services/api.js';

// --- DEKLARASIKAN SEMUA STATE DI ATAS ---
const profile = ref(null);
const isLoading = ref(true);
const isSaving = ref(false);
const isUploading = ref(false); // <-- DEFINISIKAN DI SINI
const error = ref('');        // <-- DEFINISIKAN DI SINI

// --- TAMBAHKAN INI ---
const backendUrl = process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://148.230.97.203:8011'; // Ganti dengan URL backend JATIM Anda untuk development
// --------------------


onMounted(async () => {
  try {
    const response = await apiClient.get('/admin/me');
    profile.value = response.data;
  } catch (err) { 
    error.value = "Gagal memuat profil."; // Gunakan state 'error'
    console.error(err);
  } finally { 
    isLoading.value = false; 
  }
});

const handleSignatureUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  isUploading.value = true;
  error.value = ''; // Reset error
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await apiClient.post('/admin/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    
    // --- PERBAIKAN UTAMA ---
    // Update 'profile.signature_image_url', BUKAN 'newQuestion.image_url'
    if (profile.value) {
      profile.value.signature_image_url = response.data.file_url;
    }
    // -----------------------

  } catch (err) {
    error.value = "Gagal mengupload gambar tanda tangan.";
    console.error(err);
  } finally {
    isUploading.value = false;
  }
};

const saveProfile = async () => {
  if (!profile.value) return;
  isSaving.value = true;
  error.value = '';
  try {
    const response = await apiClient.put('/admin/me', profile.value);
    profile.value = response.data;
    alert("Profil berhasil diperbarui.");
  } catch (err) { 
    error.value = "Gagal menyimpan profil.";
    alert(error.value);
    console.error(err);
  } finally { 
    isSaving.value = false; 
  }
};
</script>
<style scoped>
.admin-profile {
  max-width: 700px;
}

h1 {
  margin-top: 0;
  margin-bottom: 20px;
}

.card {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

form {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Jarak antar elemen form */
}

form label {
  font-weight: 600;
  font-size: 0.9em;
  color: #333;
  margin-bottom: 5px;
}

form input[type="text"],
form input[type="email"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1em;
  box-sizing: border-box;
}

form input[type="file"] {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}

.image-preview {
  margin-top: 10px;
  border: 1px dashed #ccc;
  padding: 10px;
  border-radius: 4px;
  width: fit-content; /* Lebar sesuai konten */
}

.image-preview img {
  max-width: 150px;
  max-height: 100px;
  display: block;
}

button {
  padding: 12px 20px;
  background-color: #1abc9c;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start; /* Tombol tidak merentang penuh */
  transition: background-color 0.2s;
}

button:hover:not(:disabled) {
  background-color: #16a085;
}

button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}
</style>